import type { TermDetails } from '../signup/SignupForm'

export const PROVIDER_NAMES: { [key: string]: string } = {
  kakao: '카카오',
  google: '구글',
  apple: '애플'
}

export const TERM_DETAILS_CONTENT: TermDetails = {
  required1: {
    title: '개인정보 취급방침'
  },
  required2: {
    title: '서비스 이용약관'
  }
}
